import reduceReducers from 'reduce-reducers'
import createFetchModule from '@utils/store/createFetchModule'
import createFetchSubmodule from '@utils/store/createFetchSubmodule'
import { FetchActionsWith } from '@typings/generic'

export const moduleName = 'missingStockGrid'

const fetchModule = createFetchModule('@store/MissingStockGrid', 'LOAD', moduleName)
const exportSubmodule = createFetchSubmodule('@store/MissingStockGrid', 'EXPORT', moduleName)

export const actionTypes = {
  ...fetchModule.actionTypes,
  export: exportSubmodule.actionTypes,
}

export default reduceReducers(fetchModule.reducer)

export const actions: FetchActionsWith<typeof actionTypes> = {
  ...fetchModule.actions,
  export: exportSubmodule.actions.run,
}

export const selectors: Selectors = {
  ...fetchModule.selectors,
  // ... ownSelectors
}
